var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-width-container",class:[
    `max-width-container--${_vm.size}`,
    { 'max-width-container--grid': _vm.grid },
    { 'max-width-container--left': _vm.left },
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }